export default function AllotmentsEditorRoomSelectButton({
  selectAll,
  deselectAll,
}) {
  return (
    <div className="flex space-x-1 cursor-pointer text-gray-400">
      <i
        className="far fa-check-circle hover:text-k-orange transition"
        onClick={selectAll}
      />
      <i
        className="far fa-circle hover:text-k-orange transition"
        onClick={deselectAll}
      />
    </div>
  );
}
